import { AddToLibraryIcon, CheckIcon, WishlistIcon } from "@/components/appIcons";
import { catalogListActionVisibility } from "@/components/lists/catalog-list-action-visibility";
import { CatalogListAction } from "@/components/lists/CatalogListAction";
import { cn } from "@/lib/utils";

export function CatalogListActionsView({
  collectionLabel,
  collectionShortLabel,
  inCollection,
  inWishlist,
  onCollectionClick,
  onWishlistClick,
  wishlistLabel,
  wishlistPending,
  wishlistRemoveConfirmation,
  wishlistShortLabel,
}: {
  collectionLabel: string;
  collectionShortLabel: string;
  inCollection: boolean;
  inWishlist: boolean;
  onCollectionClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onWishlistClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  wishlistLabel: string;
  wishlistPending: boolean;
  wishlistRemoveConfirmation?: {
    cancelLabel: string;
    confirmLabel: string;
    description: string;
    onConfirm: () => void;
    title: string;
  };
  wishlistShortLabel: string;
}) {
  const actionVisibility = catalogListActionVisibility(inCollection, inWishlist);

  return (
    <div
      className={cn(
        "grid min-w-0 flex-1 gap-2",
        actionVisibility.wishlist ? "grid-cols-2" : "grid-cols-1",
      )}
    >
      <CatalogListAction
        active={inCollection}
        activeClassName="border-green-600/30 bg-green-600/15 text-green-500 hover:bg-green-600/25"
        fullLabel={collectionLabel}
        icon={inCollection ? CheckIcon : AddToLibraryIcon}
        onClick={onCollectionClick}
        shortLabel={collectionShortLabel}
      />
      {actionVisibility.wishlist && (
        <CatalogListAction
          active={inWishlist}
          activeClassName="border-pink-600/30 bg-pink-600/15 text-pink-500 hover:bg-pink-600/25"
          confirmation={wishlistRemoveConfirmation}
          fullLabel={wishlistLabel}
          icon={WishlistIcon}
          onClick={onWishlistClick}
          pending={wishlistPending}
          shortLabel={wishlistShortLabel}
        />
      )}
    </div>
  );
}
